export default __webpack_public_path__ + "static/media/SnapchatLogo.ee843597.png";